<template>
  <div class="fillcontain">
    <div class="center">
      <div class="lefts" style="background-color: #FFFFFF;box-shadow: 0px 1px 4px 0px  rgba(0, 0, 0, 0.1);">
        <Inboundlisttow :titleList="titleList"></Inboundlisttow>
      </div>
      <div class="contextBox">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Inboundlisttow from '../../components/Inboundlist-tow.vue'
import Inboundlistcenter from '../Inboundlist/components/Inboundlist-center.vue'
export default {
  components: {
    Inboundlisttow,
    Inboundlistcenter
  },
  data() {
    return {
      titleList: [],
      onchage: -1,
      show: false
    }
  },
  async created() {
  },
  async mounted() {
    this.onchage = 0
    this.show = true
    this.userInfoMun()


  },
  computed: {

  },
  methods: {
    userInfoMun() {
      // //console.log(this.$route.query.MenuID, "NodeID")
      
      let NodeID = this.$route.query.NodeID
      let data = JSON.parse(localStorage.getItem("MenusData"))
      data.Menus.map((item, index) => {
        if (item.NodeID == 1) {
          this.titleList = item.Nodes
          //console.log(this.titleList, 'titleListsssssssssssss')
        }
        
      })
    },
    titlelistclick(index, router) {
      if (index != this.onchage) {
        this.onchage = index
      }
      this.$router.push({ name: router })
    }
  },

}
</script>

<style lang= "less" scoped>
@import "../../style/mixin.less";

.center {
  /* 定宽 */
  .zwidth(100%);
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 20px;
}
</style>